import { DataBean } from "../DataBean";


export class SocialSecurityType extends DataBean {

    public async getSocialSecurityTypeCatalog(idEmployeeLiquidate: number,type:number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getSocialSecurityTypeCatalog_Number_Number", 
            [idEmployeeLiquidate,type]);
    }

    public async getSocialSecurityTypeConstants(): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getSocialSecurityTypeConstants_Number", 
            [null]);
    }

    public async updateSocialSecurityType(bean: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.employees.SocialSecurityType_updateSocialSecurityType_com.quickdataerp.bean.employees.SocialSecurityType", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.quickdataerp.bean.employees.SocialSecurityType"
              }
        ]);
    }

    public async deleteSocialSecurityType(idSocialSecurityType: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteSocialSecurityType_Number", [idSocialSecurityType]);
    }

}